import { useMemo } from 'react';
import { App } from '@back4app2/sdk';
import StatusError from './StatusError';
import StatusSpinner from './StatusSpinner';
import StatusSuccess from './StatusSuccess';
import StatusQueued from './StatusQueued';
import StatusPill from './ds/StatusPill';
import { AppStatusTone, getAppStatusSummary } from '../utils/appStatus';

const ICONS: Record<AppStatusTone, typeof StatusError> = {
  ok: StatusSuccess,
  error: StatusError,
  warn: StatusQueued,
  info: StatusSpinner,
  idle: StatusQueued,
};

const MyAppStatus = ({ app, variant = 'inline' }: {
  app: App,
  /**
   * `pill` is the container header's reading of the state — the artboards give
   * it the state's own colour, because on that screen the status IS the answer
   * to why you opened the page. `inline` keeps the icon-and-label shape the
   * app list uses, where a row of coloured pills would just be noise.
   */
  variant?: 'inline' | 'pill',
}) => {
  const { Icon, text, tone } = useMemo(
    () => {
      const summary = getAppStatusSummary(app);
      return { Icon: ICONS[summary.tone], text: summary.text, tone: summary.tone };
    },
    [app]
  );

  if (variant === 'pill') {
    return <StatusPill tone={tone}>{text}</StatusPill>;
  }

  return (
    <div className="flex items-center">
      <Icon />
      <div className="ml-[0.3125rem] text-navy-100 text-ds-115 leading-[140%] whitespace-nowrap">
        {text}
      </div>
    </div>
  );
}

export default MyAppStatus;
